<template>
  <ModuleContainer>
    <slot />
  </ModuleContainer>
</template>

<script>
import L from "@/plugins/leaflet";
import ModuleMixin from "@/components/Map/ModuleMixin";

export default {
  mixins: [ModuleMixin],

  props: {
    complaint: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      markerLayer: null
    };
  },

  methods: {
    onInit() {
      // Use this.map to access leaflet map
      this.markerLayer = L.marker([
        this.complaint.latitude,
        this.complaint.longitude
      ]);

      if (this.complaint.ward)
        this.markerLayer.bindPopup(
          this.complaint.ward && this.complaint.ward.name
        );

      this.map.addLayer(this.markerLayer);

      this.map.setView([this.complaint.latitude, this.complaint.longitude]);
    },

    onDestroy() {
      if (this.markerLayer) {
        this.map.removeLayer(this.markerLayer);
        this.markerLayer = null;
      }
    }
  }
};
</script>
